import { Head } from 'vite-react-ssg'

import { useBranding } from './BrandingProvider'

// Brand-aware default <title>/OG. Rendered INSIDE BrandingProvider so it overrides
// RootLayout's static Zenzers default once the per-domain config resolves (the head
// manager takes the last-registered title). Per-page <Seo> still overrides this.
// Fixes the Crownring tab reading "Zenzers — Geriatric Remote Monitoring".
export function BrandHead() {
  const { siteName, tagline } = useBranding()
  // Preserve Zenzers' established SEO title; other brands derive from their config.
  const title = siteName.toLowerCase().includes('zenzers')
    ? 'Zenzers — Geriatric Remote Monitoring & Fall Detection'
    : `${siteName} — ${tagline}`
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={`${siteName}: ${tagline}.`} />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={siteName} />
    </Head>
  )
}
